<button class="btn btn-secondary rounded-circle position-fixed" (click)="goBack()" style="bottom: 40px; left: 40px;">
    <i class="fa-solid fa-chevron-left" style="font-size: 2em;"></i>
</button>